import AxiosAPIInterface from "./axios-api-interface";

export default class LoginAPI extends AxiosAPIInterface {
	constructor() {
		if (LoginAPI._instance) {
			return LoginAPI._instance;
		}
		super({ resoucePath: "" });
		LoginAPI._instance = this;
	}

	login(Authorization) {
		return this.post({ path: "/login", headers: { Authorization } });
	}
	refreshToken(body) {
		return this.post({ path: "/login/token/refresh", body });
	}
	authenticate(token) {
		return this.get({
			path: "/authenticate",
			headers: { access_token: `bearer ${token}` }
		}).then(response => {
			const { integrationStatus } = response;
			if (Object.keys(integrationStatus).length !== 0) {
				if (integrationStatus.syncDetails)
					integrationStatus.syncDetails = JSON.parse(
						integrationStatus.syncDetails
					);
				if (integrationStatus.additionInfo)
					integrationStatus.additionInfo =
						typeof integrationStatus.additionInfo === "string"
							? JSON.parse(integrationStatus.additionInfo)
							: integrationStatus.additionInfo;
				if (integrationStatus.preferences)
					integrationStatus.preferences = JSON.parse(
						integrationStatus.preferences
					);
			}
			return {
				...response,
				integrationStatus
			};
		});
	}
}
